<template>
  <h1 class="text-center">Category Pages</h1>

</template>

<script>
export default {
  name: "CategoryPages"
}
</script>

<style scoped>

</style>